import { NgModule, isDevMode } from '@angular/core';
import {
  BrowserModule,
  provideClientHydration,
} from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FullComponent } from './layouts/full/full.component';
import { AngularFireModule } from '@angular/fire/compat';
import {
  AngularFireMessagingModule,
  SERVICE_WORKER,
} from '@angular/fire/compat/messaging';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NavbarComponent } from './components/navbar/navbar.component';
import { BottombarComponent } from './components/bottombar/bottombar.component';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MessagesModule } from 'primeng/messages';
import { DialogModule } from 'primeng/dialog';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { MenubarModule } from 'primeng/menubar';
import { ToastModule } from 'primeng/toast';
import { TranslocoRootModule } from './transloco-root.module';
import { CheckboxModule } from 'primeng/checkbox';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { RatingModule } from 'primeng/rating';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';

@NgModule({
  declarations: [
    AppComponent,
    FullComponent,
    BottombarComponent,
    NavbarComponent,
  ],
  imports: [
    BrowserModule,
    MessagesModule,
    DialogModule,
    InputSwitchModule,
    ButtonModule,
    InputTextModule,
    HttpClientModule,
    MenubarModule,
    BrowserAnimationsModule,
    CommonModule,
    AppRoutingModule,
    FormsModule,
    ToastModule,
    TieredMenuModule,
    CheckboxModule,
    RatingModule,
    ProgressSpinnerModule,
    InputGroupAddonModule,
    InputGroupModule,
    AngularFireMessagingModule,
    AngularFireModule.initializeApp({
      apiKey: "AIzaSyBPZllQUn3KxoFIBDXLYm1XtCTjP9R4BSM",
      authDomain: "disanmarco-experience.firebaseapp.com",
      projectId: "disanmarco-experience",
      storageBucket: "disanmarco-experience.firebasestorage.app",
      messagingSenderId: "103507512068",
      appId: "1:103507512068:web:83f9ba9078efa749c7de51"
    }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
    TranslocoRootModule,
  ],
  providers: [
    provideClientHydration(),
    {
      provide: SERVICE_WORKER,
      useFactory: () =>
        (typeof navigator !== 'undefined' &&
          navigator.serviceWorker?.register('firebase-sw.js', {
            scope: '__',
          })) ||
        undefined,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
